function resizeWindow(){
	if($(document).width() < 1400) {
		$("body").addClass('minify');
	} else {
		$("body").removeClass('minify');
	}
}
 
function scrollDown(){
	var top = $(document).scrollTop();
	if($('header').length > 0) {
		if (top > 120) {
			$('#content').addClass('header-fix');
		} else {
			$('#content').removeClass('header-fix');
		}
	}
	if($('#langtabs').length > 0) {
		if (top > 120) {
			$('#langtabs').addClass('fix');
		} else {
			$('#langtabs').removeClass('fix');
		}
	}
}

// Dark mode for every TinyMCE editor (jQuery and Vue), whatever its content_css
function applyEditorViewMode(editor) {
	var body = editor.getBody();
	if (!body) {
		return;
	}
	// body.dark is only added on document ready, so fall back to the stored mode
	var dark = $('body').hasClass('dark') || localStorage.getItem("view-mode") == 'dark';
	body.classList.toggle('dark', dark);
	body.classList.toggle('light', !dark);
	if (!editor.dom.get('view-mode-style')) {
		var style = editor.dom.create('style', {id: 'view-mode-style'}, 'body.dark{background-color:transparent;color:#D0D0D0}body.dark a{color:#07E2C9}');
		editor.getDoc().head.appendChild(style);
	}
}
if (typeof tinymce !== 'undefined') {
	tinymce.on('AddEditor', function (e) {
		e.editor.on('init', function () {
			applyEditorViewMode(e.editor);
		});
	});
}

$(document).ready(function () {


	//View Mode
	$('.view-mode').click(function (e) {
		e.preventDefault();
		if($('body').hasClass('light')) {
			$new_mode = 'dark';
			$('body').removeClass('light');
			$('body').addClass('dark');
		} else {
			$new_mode = 'light';
			$('body').removeClass('dark');
			$('body').addClass('light');
		}
		localStorage.setItem("view-mode", $new_mode);
		// Keep open TinyMCE editors in sync
		if (typeof tinymce !== 'undefined') {
			tinymce.editors.forEach(applyEditorViewMode);
		}
	});	
	if(localStorage.getItem("view-mode") == 'dark') {
		$('body').addClass('dark');
	}
	if(localStorage.getItem("view-mode") == 'light' || localStorage.getItem("view-mode") == '') {
		$('body').addClass('light');
	}
	$('.sidebar__collapse').click(function (e) {
		$(this).toggleClass('active');
		$('body').toggleClass('minify');
		if($('body').hasClass('minify')) {
			$sidebar_mode = 'minify';
			$('.main-nav li').removeClass('open');
		} else {
			$sidebar_mode = 'full';
		}
		localStorage.setItem("sidebar", $sidebar_mode);
	});
	if(localStorage.getItem("sidebar") == 'minify') {
		$('body').addClass('minify');
		$('.sidebar__collapse').toggleClass('active');
		$('.main-nav li').removeClass('open');
	}
	setTimeout(function(){
		$("body").css("opacity",1);
    }, 200);

	//resizeWindow();
	$(window).resize(function(event) {
		//resizeWindow();
	}); 
	$(window).scroll(function (event) {
		scrollDown();
	});

	//clear site cache
	$('.btnClearSiteCache').click(async function() {
		if($("#clearCacheProcess").val() == 0){
			$("#clearCacheProcess").val(1);
			$(".clearCacheLoading").fadeIn(200);
            
			//await $.get(SITE_ROOT + 'ajax/sites_process.php', {
			//	operation: 'clearSiteCache',
			//	id: $('input[type="hidden"]#id').val()
			//});
            try {
                const response = await fetch(SITE_ROOT + 'ajax/sites_process.php?operation=clearSiteCache', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                const data = await response.json();
                
            if(data.clear_page_cache === 'ok'){
                toastr['success']('Site cache was deleted.');
            }else if(data.clear_page_cache === 'error'){
                toastr['error']((data.msg || 'Error deleting cache, please try again.'));
            }
            } catch (error) {
                console.log(error);
            } finally {
                $("#clearCacheProcess").val(0);
                $(".clearCacheLoading").hide();
            }
		}
	});
   	
   	//Tooltips 
	$('[data-toggle="tooltip"]').tooltip();

	$('.nav-tabs a').click(function (e) {
		e.preventDefault();
		$('.nav-tabs a').removeClass('active');
		$(this).addClass('active');
		var target = $(this).attr('href').replaceAll( ' ',  '-' );
		$('.tab-content .tab-pane').fadeOut(300); 
		$(target).fadeIn(350);
	});
	$('.alert__title').click(function (e) {
		e.preventDefault();
		$(this).siblings().slideToggle();
	});

	//Translation module
	$('#keys .trans__col--unit input').focusin(  
	  	function(){  
	    	var $index = $(this).attr('tabindex');
			$index = parseInt($index)+1;
			$('.divTranslation input[tabindex = '+$index+']').addClass('focus');
		}).focusout(  
	    function(){  
	    	$('.divTranslation input').removeClass('focus');  
	});
	$('.divTranslation .trans__col--unit input').focusin(  
	  	function(){  
	    	var $index = $(this).attr('tabindex');
			$index = parseInt($index)-1;
			$('#keys input[tabindex = '+$index+']').addClass('focus');
		}).focusout(  
	    function(){  
	    	$('#keys input').removeClass('focus');  
	});

	//Sidebar
	$('a.has-sublinks').click(function (e) {
		e.preventDefault();
		if($(this).parent().hasClass('open')) {
			$(".main-nav li").removeClass('open');
		} else {
			$(".main-nav li").removeClass('open');
			$(this).parent().addClass('open');
		}
	});
	$('a.showHistory').click(function (e) {
		e.preventDefault();
		$('#main').fadeToggle();
		$('#history-tab').fadeToggle();
	});
	var tranlation_class_body;
	$('a.showContent').click(function (e) {
		e.preventDefault();

		tranlation_class_body = $(this).html()
		if( !$('body').hasClass( tranlation_class_body ) && !$('.nav.nav-tabs li:first a').hasClass('active') ){
			$('.nav.nav-tabs li:first a').click();
		}	

		$('#main').fadeToggle();
		$('body').toggleClass(tranlation_class_body);
		$($(this).attr("href")).fadeToggle();
			
	});

	// $('.main-nav a.has-sublinks').each(function(i) {
	// 	$target = $(this).parent('li');
	// 	if($target.children('.dropdown ul').length == 0) {
	// 		$($target).hide();
	// 	}
	// });

	$(".fancybox").fancybox({
        'padding':0,
        'scrolling'     :   'auto',
        'nextEffect'    :   'fade',
        'prevEffect'    :   'fade',
        helpers     : {
            title: {
                type: 'inside'
            }
        }
    });

	$(".chosen-select").chosen();

	$(".header li, .top-bar .menu li").hover(function(){
        var target = $(this).find('ul');
        window.mytimeout = setTimeout(function(){
            target.addClass("hover");
            $(target).fadeIn(400);
        }, 200);
    }, function(){
        var target = $(this).find('ul');
        if($(target).hasClass("hover")) {
            $(target).removeClass("hover");
            $(target).fadeOut(400);
        } else {
            clearTimeout(window.mytimeout);
        }
    });
    if($('body').hasClass('minify')) {
    	$(".main-nav li").hover(function(){
	        var target = $(this).find('.dropdown');
	        window.minifytimeout = setTimeout(function(){
	            target.addClass("hover");
	            $(target).fadeIn(400);
	        }, 200);
	    }, function(){
	        var target = $(this).find('.dropdown')
	        if($(target).hasClass("hover")) {
	            $(target).removeClass("hover");
	            $(target).fadeOut(200);
	        } else {
	            clearTimeout(window.minifytimeout);
	        }
	    });
    }
	
	
});
function selectSite(site_id) {
	$.ajax({
		type: "POST",
		url: SITE_ROOT+"ajax/admin_sites_process.php",
		dataType: "json",
		data:{
			site_id : site_id,
			operation : 'selectSite'
		},
		success: function(data){ 
			if(typeof data.redirect !== 'undefined') {
				window.location = data.redirect;
			} else if(data.result=='success'){	
				window.location = SITE_ROOT+data.current_site.site_id+"/index";
            } else if(data.result=='products'){	
				createProductOptions(data.products,data.current_site.site_id);
            }
			
		}
	});
} 

function createProductOptions(productGroups, site_id){

	////// create a tag <a> fo each product in the div .login_product_selector
	let html = '<div class="wrap"><ul class="product_selector_list">';
	for (const groupName in productGroups) {
		const groupItems = productGroups[groupName];
		// if (groupItems.length === 1) {
		// 	const item = groupItems[0];
		// 	html += `<li 
		// 		data-id="${item.id}" 
		// 		class="product-item"
		// 		style="cursor:pointer;"
		// 	>
		// 		<div class="name">${item.name}</div>
		// 		<p>${item.description}</p>
		// 		<ul>`;
		// 		html += `<li 
		// 			data-id="${item.id}" 
		// 			class="product-item"
		// 			style="cursor:pointer;"
		// 		>
		// 			All in one
		// 		</li>`;
		// 	html += `</ul>
		// 	</li>`;
		// } else {
			html += `<li> 
				<div class="name">${groupName}</div>
				<p>${productGroups[groupName][0]["description"]}</p>
				<ul>`;
			for (const item of groupItems) {
				html += `<li 
					data-id="${item.id}" 
					class="product-item"
					style="cursor:pointer;"
				>
					${item.name}
				</li>`;
			}
			html += `</ul>
			</li>`;
		//}
	}
	html += '</ul></div>';

	$('.product_selector').html(html);
	$('.product-item').click(function(e){ 
		e.preventDefault();
		var product_id = $(this).data('id');
		$.ajax({
			type: "POST",
			url: SITE_ROOT+"ajax/admin_sites_process.php",
			dataType: "json",
			data:{
				product_id : product_id,
				operation : 'selectProduct',
				site_id: site_id
			},
			success: function(data){ 	
				window.location = SITE_ROOT+"index.php";
			}
		});  
	});
}
